import { render, staticRenderFns } from "./JournalSystemList.vue?vue&type=template&id=26592a54"
import script from "./JournalSystemList.vue?vue&type=script&lang=js"
export * from "./JournalSystemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports